// extracted by mini-css-extract-plugin
export default {"select-btn":"FileUploader_select-btn__6K7rU"};